// constants/BrandAssets.js

//TODO: replace privacy policies for UK market

export const BrandAssets = {
    FredericMalle: {
        US: {
            logoPath: 'FredericMalle/image.png',
            headerName: 'Frederic Malle',
            privacyPolicyLink: 'https://www.fredericmalle.com/customer-service-privacy',
        },
        UK: {
            logoPath: 'FredericMalle/image.png',
            headerName: 'Frederic Malle',
            privacyPolicyLink: 'https://www.fredericmalle.com/customer-service-privacy',
        },
        FR: {
            logoPath: 'FredericMalle/image.png',
            headerName: 'Frederic Malle',
            privacyPolicyLink: 'https://www.fredericmalle.eu/fr-e-UF/customer-service-privacy',
        },
    },
    MAC: {
        US: {
            logoPath: 'MAC/image.png',
            headerName: 'MAC',
            privacyPolicyLink: 'https://www.maccosmetics.com/privacy-policy',
        },
        UK: {
            logoPath: 'MAC/image.png',
            headerName: 'MAC',
            privacyPolicyLink: 'https://www.maccosmetics.com/privacy-policy',
        },
        FR: {
            logoPath: 'MAC/image.png',
            headerName: 'MAC',
            privacyPolicyLink: 'https://www.maccosmetics.fr/privacy-policy',
        },
    },
    BobbiBrown: {
        US: {
            logoPath: 'BobbiBrown/image.png',
            headerName: 'Bobbi Brown',
            privacyPolicyLink: 'https://www.bobbibrowncosmetics.com/privacy-policy',
        },
        UK: {
            logoPath: 'BobbiBrown/image.png',
            headerName: 'Bobbi Brown',
            privacyPolicyLink: 'https://www.bobbibrowncosmetics.com/privacy-policy',
        },
        FR: {
            logoPath: 'BobbiBrown/image.png',
            headerName: 'Bobbi Brown',
            privacyPolicyLink: 'https://www.bobbibrowncosmetics.fr/customer-service-corporate#corporate-privacy',
        },
    },
    TomFord: {
        US: {
            logoPath: 'TomFord/image.png',
            headerName: 'Tom Ford',
            privacyPolicyLink: 'https://www.tomfordbeauty.com/privacy',
        },
        UK: {
            logoPath: 'TomFord/image.png',
            headerName: 'Tom Ford',
            privacyPolicyLink: 'https://www.tomfordbeauty.com/privacy',
        },
        FR: {
            logoPath: 'TomFord/image.png',
            headerName: 'Tom Ford',
            privacyPolicyLink: 'https://www.tomfordbeauty.com/privacy',
        },
    },
    LaMer: {
        US: {
            logoPath: 'LaMer/image.png',
            headerName: 'La Mer',
            privacyPolicyLink: 'https://www.cremedelamer.com/customer-service-privacy-policy',
        },
        UK: {
            logoPath: 'LaMer/image.png',
            headerName: 'La Mer',
            privacyPolicyLink: 'https://www.cremedelamer.com/customer-service-privacy-policy',
        },
        FR: {
            logoPath: 'LaMer/image.png',
            headerName: 'La Mer',
            privacyPolicyLink: 'https://www.cremedelamer.fr/customer-service-privacy-policy',
        },
    },
    ByKilian: {
        US: {
            logoPath: 'ByKilian/image.png',
            headerName: 'By Kilian',
            privacyPolicyLink: 'https://www.bykilian.com/customer-service-privacy-policy',
        },
        UK: {
            logoPath: 'ByKilian/image.png',
            headerName: 'By Kilian',
            privacyPolicyLink: 'https://www.bykilian.com/customer-service-privacy-policy',
        },
        FR: {
            logoPath: 'ByKilian/image.png',
            headerName: 'By Kilian',
            privacyPolicyLink: 'https://www.bykilian.fr/service-client-politique-de-confidentialite',
        },
    },
    Clinique: {
        US: {
            logoPath: 'Clinique/image.png',
            headerName: 'Clinique',
            privacyPolicyLink: 'https://www.clinique.com/customer-care/general-info/privacy-policy',
        },
        UK: {
            logoPath: 'Clinique/image.png',
            headerName: 'Clinique',
            privacyPolicyLink: 'https://www.clinique.com/customer-care/general-info/privacy-policy',
        },
        FR: {
            logoPath: 'Clinique/image.png',
            headerName: 'Clinique',
            privacyPolicyLink: 'https://www.clinique.fr/customer-care/general-info/privacy-policy',
        },
    },
    EsteeLauder: {
        US: {
            logoPath: 'EsteeLauder/image.png',
            headerName: 'Estée Lauder',
            privacyPolicyLink: 'https://www.esteelauder.com/privacy',
        },
        UK: {
            logoPath: 'EsteeLauder/image.png',
            headerName: 'Estée Lauder',
            privacyPolicyLink: 'https://www.esteelauder.com/privacy',
        },
        FR: {
            logoPath: 'EsteeLauder/image.png',
            headerName: 'Estée Lauder',
            privacyPolicyLink: 'https://www.esteelauder.fr/privacy-policy',
        },
    },
}